import {Component, Injector} from "@angular/core";
import {provideSearchModel} from "@fedeltapointofsale/data-client";
import {PeriodScheduleSearchModel} from "../period-schedule-search.model";
import {PeriodScheduleSearchPageComponent} from "../period-schedule-search-page/period-schedule-search-page.component";
import {PeriodScheduleEditPageComponent} from "../period-schedule-edit-page/period-schedule-edit-page.component";
import {
    registerSelectEditControl
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-select-edit-control.component";
import {
    AbstractMultiSelectEditControlComponent
} from "../../../framework/entity/edit/edit-controls/select-edit-controls/abstract-multi-select-edit-control.component";

@Component({
    selector: "wbo-period-schedule-multi-select-edit-control",
    templateUrl: "../../../framework/entity/edit/edit-controls/select-edit-controls/multi-select-edit-control.component.html",
    providers: [
        provideSearchModel(PeriodScheduleSearchModel),
        registerSelectEditControl(PeriodScheduleMultiSelectEditControlComponent)
    ]
})
export class PeriodScheduleMultiSelectEditControlComponent extends AbstractMultiSelectEditControlComponent<PeriodScheduleSearchModel> {
    constructor(model: PeriodScheduleSearchModel, injector: Injector) {
        super(model, injector, "id", "name");

        this.extendedSearchComponent = PeriodScheduleSearchPageComponent;
        this.extendedEditComponent = PeriodScheduleEditPageComponent;
    }
}
